import { render, staticRenderFns } from "./VideoMessage.vue?vue&type=template&id=0cc70ae3&scoped=true"
import script from "./VideoMessage.vue?vue&type=script&lang=js"
export * from "./VideoMessage.vue?vue&type=script&lang=js"
import style0 from "./VideoMessage.vue?vue&type=style&index=0&id=0cc70ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc70ae3",
  null
  
)

export default component.exports